import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import withAuthGuard from '../withAuthGuard';

import { Invoice } from '../../components/MyAccount/invoices/Invoice';

import { selectActivePlanSubscription, selectIsSubscriptionFromApps, selectSubscriptionMethodId } from '../../queries/selectors/products';
import { selectCurrentContentFichaPath } from '../../queries/selectors/contents';
import { selectSubscriberConfig, selectReturnURLPath, selectProductsEntities, selectInvoicesEntities } from '../../queries/selectors/bootstrap';
import { requestAsync } from '../../queries/actions';
import { getInvoicesBySubscriber } from '../../queries/invoice';

import withMembershipPurchased from '../withMembershipPurchased';
import withPaymentStatus from '../withPaymentStatus';
import { selectClient, selectCancellationMethod } from '../../global-selectors';
import { selectCurrentPaymentMethod } from '../../queries/selectors/payment';
import { selectUserData } from '../../queries/selectors/user';
import { injectIntl } from 'react-intl';

const mapStateToProps = (state) => ({
  userPlan: selectActivePlanSubscription(state),
  path: selectReturnURLPath(state) || selectCurrentContentFichaPath(state) + 'my-account',
  subscriber: selectSubscriberConfig(state),
  isSubscriptionFromApps: selectIsSubscriptionFromApps(state),
  subscriptionMethodId: selectSubscriptionMethodId(state),
  paymentMethod: selectCurrentPaymentMethod(state),
  client: selectClient(state),
  user: selectUserData(state),
  cancellationFlow: selectCancellationMethod(state),
  products: selectProductsEntities(state),
  invoices: selectInvoicesEntities(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getInvoices: (data) => requestAsync(getInvoicesBySubscriber, data)
}, dispatch);

export default compose(
  withPaymentStatus,
  withMembershipPurchased,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
  withAuthGuard({ toLoginURL: true })
)(Invoice);
